/* eslint-disable global-require */
import { HTTP_OK, HTTP_ERROR_500, HTTP_NOT_FOUND, HTTP_GONE } from './utils/http-status';
import { notFound, explicit404Routes } from './site-modules/venom/routes/not-found';
import { error } from './site-modules/venom/routes/error';
import { gone } from './site-modules/venom/routes/gone';
import { isSiteModuleEnabled } from './utils/is-site-module-enabled';

const subdomainRoutesMap = {
  'test-microsite': true
    ? {
        routes: () =>
          Array.prototype.concat(
            require('./site-modules/microsite/test-microsite/routes/demo').routes,
            require('./site-modules/microsite/test-microsite/routes/error').routesErrorDemo,
            require('./site-modules/microsite/test-microsite/routes/gone').routesGoneDemo,
            require('./site-modules/microsite/test-microsite/routes/not-found').routesNotFound // this MUST be the last require in this array
          ),
        routesNotFound: () => require('./site-modules/microsite/test-microsite/routes/not-found').routesNotFound,
        routesGone: () => require('./site-modules/microsite/test-microsite/routes/gone').routesGone,
        routesError: () => require('./site-modules/microsite/test-microsite/routes/error').routesError,
      }
    : null,
  dealers: true
    ? {
        routes: () =>
          Array.prototype.concat(
            require('./site-modules/venom/routes/error').routes,
            require('./site-modules/microsite/dealers/routes/dealer-center').testRoutes,
            require('./site-modules/microsite/dealers/routes/dealer-center').routes,
            require('./site-modules/microsite/dealers/routes/dealer-center').notFound // this MUST be the last require in this array
          ),
        routesNotFound: () => require('./site-modules/microsite/dealers/routes/dealer-center').notFound,
        routesGone: () => require('./site-modules/microsite/dealers/routes/dealer-center').gone,
        routesError: () => require('./site-modules/microsite/dealers/routes/dealer-center').error,
      }
    : null,
};

const getSubdomainRoutes = (subdomain, routeType) => {
  if (subdomainRoutesMap[subdomain]) {
    return subdomainRoutesMap[subdomain][routeType]();
  }
  return null;
};

export const routes = subdomain => {
  const subdomainRoutes = getSubdomainRoutes(subdomain, 'routes');
  if (subdomainRoutes) {
    return subdomainRoutes;
  }
  return Array.prototype.concat(
    require('./site-modules/upper-funnel/routes/home').routes,
    explicit404Routes, // any explicit 404s will take precedence over other routes,
    true ? require('./site-modules/venom/routes/error').routes : [],
    true ? require('./site-modules/venom/routes/model-demo').routes : [],
    true ? require('./site-modules/venom/routes/testpages').routes : [],
    true ? require('./site-modules/sitemap/routes/sitemap').routes : [],
    true ? require('./site-modules/appraiser/routes/appraiser').routes : [],
    true ? require('./site-modules/appraisal/routes/appraisal').routes : [],
    true ? require('./site-modules/price-checker/routes/price-checker').routes : [],
    true ? require('./site-modules/dealerships/routes/dealer-details-page').routes : [],
    true ? require('./site-modules/dealerships/routes/dealerships-landing').routes : [],
    true ? require('./site-modules/dealerships/routes/dealer-review').routes : [],
    true
      ? require('./site-modules/consumer-ratings-reviews/routes/consumer-ratings-reviews').routes
      : [],
    true
      ? require('./site-modules/used-cars-landing/routes/used-cars-for-sale').routes
      : [],
    true
      ? require('./site-modules/car-reviews-landing/routes/car-reviews').routes
      : [],
    true ? require('./site-modules/cpo/routes/cpo').routes : [],
    true ? require('./site-modules/incentives/routes/incentives').routes : [],
    true
      ? require('./site-modules/car-maintenance/routes/car-maintenance').routes
      : [],
    true ? require('./site-modules/dealer-ico-widget/routes').routes : [],
    true ? require('./site-modules/financing/routes/financing').routes : [],
    true ? require('./site-modules/lease-deals/routes/lease-deals').routes : [],
    true ? require('./site-modules/new-car-deals/routes/new-car-deals').routes : [],
    true ? require('./site-modules/multi-offer/routes/multi-offer').indexAppRoutes : [], // The multi-offer index.app routes need to take precedence over editorial routes due to route conflict with research article routes.
    true ? require('./site-modules/editorial/routes').routes : [],
    true ? require('./site-modules/profile/routes/dashboard').routes : [],
    true ? require('./site-modules/profile/routes/auth-action').routes : [],
    true ? require('./site-modules/profile/routes/process-search').routes : [],
    true ? require('./site-modules/car-buying/routes/car-buying').routes : [],
    require('./site-modules/health-check/routes/health-check').routes,
    true ? require('./site-modules/comparator/routes/comparator').routes : [],
    true ? require('./site-modules/examples/routes/examples').routes : [],
    true ? require('./site-modules/inventory/routes/make-type').routes : [],
    true ? require('./site-modules/make/routes/make').routes : [],
    true ? require('./site-modules/features-specs/routes/features-specs').routes : [],
    true
      ? require('./site-modules/consumer-reviews/routes/consumer-reviews').routes
      : [],
    true ? require('./site-modules/mpg/routes/mpg').routes : [],
    true ? require('./site-modules/build-price/routes/build-price').routes : [],
    true ? require('./site-modules/cost-to-own/routes/cost-to-own').routes : [],
    true ? require('./site-modules/pictures/routes/pictures').routes : [],
    true ? require('./site-modules/write-review/routes/write-review').routes : [],
    true ? require('./site-modules/lead-form/routes').routes : [],
    true
      ? require('./site-modules/long-term-road-test/routes/long-term-road-test').routes
      : [],
    true
      ? require('./site-modules/new-cars-landing/routes/new-car-pricing').routes
      : [],
    true ? require('./site-modules/inventory/routes/srp').routes : [],
    true ? require('./site-modules/core-page/routes/highlights').routes : [],
    true ? require('./site-modules/core-page/routes/connect').routes : [],
    true ? require('./site-modules/inventory/routes/vdp').routes : [],
    true ? require('./site-modules/upper-funnel/routes/type').routes : [],
    true ? require('./site-modules/upper-funnel/routes/best').routes : [],
    true ? require('./site-modules/upper-funnel/routes/subtype').routes : [],
    true ? require('./site-modules/upper-funnel/routes/true-budget').routes : [],
    true ? require('./site-modules/upper-funnel/routes/video-landing').routes : [],
    true
      ? require('./site-modules/basic-ad-page-speed/routes/basic-ad-page-speed').routes
      : [],
    true ? require('./site-modules/industry-center/routes/industry').routes : [],
    true ? require('./site-modules/calculators/routes/calculators').routes : [],
    true ? require('./site-modules/inventory/routes/self-reported-sale').routes : [],
    true ? require('./site-modules/payments/routes/payments').routes : [],
    true
      ? require('./site-modules/data-privacy-request/routes/data-privacy-request').routes
      : [],
    true ? require('./site-modules/infographics/routes/index').routes : [],
    true ? require('./site-modules/partners/routes/partners').routes : [],
    true ? require('./site-modules/brand-landing/routes').routes : [],
    true ? require('./site-modules/shared/routes/mmy').routes : [],
    true ? require('./site-modules/wisdom-of-the-crowd/routes/deal').routes : [],
    true ? require('./site-modules/upper-funnel/routes/shopcars').routes : [],
    true ? require('./site-modules/widgets/routes').routes : [],
    true ? require('./site-modules/car-buying-online/routes').routes : [],
    true ? require('./site-modules/multi-offer/routes/multi-offer').routes : [],
    true ? require('./site-modules/rss/routes/rss').routes : [],
    true ? require('./site-modules/glossary/routes/glossary').routes : [],
    true ? require('./site-modules/site-served-ad/routes/ads').routes : [],
    true
      ? require('./site-modules/personalized-search/routes/personalized-search').routes
      : [],
    true
      ? require('./site-modules/private-listing/routes/private-listing').routes
      : [],
    true ? require('./site-modules/canvas/routes/canvas').routes : [],
    true ? require('./site-modules/internal-tools/routes/internal-tools').routes : [],

    /**
     Additional route groups go here. Guard optional site modules so subset
     builds can omit their dependencies, for example:
     true ? require('./site-modules/editorial/routes').routes : []
     Each require should return an array of route objects.
     */
    require('./site-modules/venom/routes/not-found').routes // this MUST be the last require in this array
  );
};

const routesNotFound = subdomain => {
  const subdomainRoutesNotFound = getSubdomainRoutes(subdomain, 'routesNotFound');
  if (subdomainRoutesNotFound) {
    return subdomainRoutesNotFound;
  }
  return [
    ...(true ? [require('./site-modules/multi-offer/routes/multi-offer').notFound] : []),
    notFound, // this MUST be the last route
  ];
};

const routesGone = subdomain => {
  const subdomainRoutesGone = getSubdomainRoutes(subdomain, 'routesGone');
  if (subdomainRoutesGone) {
    return subdomainRoutesGone;
  }
  return [
    ...(true
      ? [require('./site-modules/car-buying-online/routes/index').gone]
      : []),
    ...(true ? [require('./site-modules/inventory/routes/vdp').gone] : []),
    gone, // this MUST be the last route
  ];
};

const routesError = subdomain => {
  const subdomainRoutesError = getSubdomainRoutes(subdomain, 'routesError');
  if (subdomainRoutesError) {
    return subdomainRoutesError;
  }
  return [error];
};

export function getRoutes(status = HTTP_OK, subdomain = null) {
  if (status === HTTP_GONE) {
    return routesGone(subdomain);
  }
  if (status >= HTTP_ERROR_500) {
    return routesError(subdomain);
  }
  if (status === HTTP_NOT_FOUND) {
    return routesNotFound(subdomain);
  }
  return routes(subdomain);
}

export function makeRouteParams(route) {
  const params = { path: route.path, component: route.page };
  if (route.exact) {
    params.exact = true;
  }
  return params;
}

export function getClientRedirects() {
  return [];
}
